export default {
    variant: 'default',
    message: '',
    open: false,
    loaded: 100
}